import { useState, useEffect } from 'react';
import { walletMockData } from '../mockData';
import IconOKX from '../assets/icon-okx.svg';
import IconWalletConnect from '../assets/icon-walletconnect.svg';
import IconPassport from '../assets/icon-passport.svg';
import IconBalance from '../assets/icon-balance.webp';
import IconZKPassport from '../assets/icon-zk-passport.png';
import IconAddress from '../assets/icon-address.webp';
import LoadingScreen from './LoadingScreen';
import { useAuth } from '../context/AuthContext'; 
import { Link } from 'react-router-dom';

const Wallet = () => {
  const [connected, setConnected] = useState(false);
  const [assets, setAssets] = useState({
    tokens: [],
    nfts: [],
    balance: 0
  });
  const { loading, setLoading, playerProfile } = useAuth();

  const wallets = [
    { id: 'passport', name: 'Passport', icon: IconPassport },
    { id: 'okx', name: 'OKX Wallet', icon: IconOKX },
    { id: 'walletconnect', name: 'Wallet Connect', icon: IconWalletConnect }
  ];

  const shortenAddress = (address) => {
    return address.slice(0, 5) + '....' + address.slice(-4);
  };

  const connectWallet = async (walletId) => {
    try {
      // Wallet connection logic here  
      setConnected(true);
    } catch (error) {
      console.error('Wallet connection failed:', error);
    }
  };

  // useEffect(() => {
  //   // if (connected) {
  //   //   // Fetch assets when wallet is connected  
  //   //   const fetchAssets = async () => {
  //   //     // API calls here  
  //   //   };

  //   //   fetchAssets();
  //   // }


  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       // Simulate API latency  
  //       await new Promise(resolve => setTimeout(resolve, 1000));
  //       // Set data  
  //       setAssets(walletMockData);
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [connected]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="p-4 flex flex-col items-between h-full justify-between">
      <div>
        <h1 className="section-title mb-10 pb-5">Wallet</h1>
        <div className="bg-[#9747ff61] rounded-lg shadow p-4 flex flex-col relative mb-4">
          <div className="absolute bottom-0 right-0 w-[200px]">
            <img src={IconZKPassport} />
          </div>
          <div className="title">Passport ID</div>
          <div className='text-[1.1rem] relative font-bold mt-2'>{playerProfile.passportID}</div>
        </div>
        <div className="grid grid-cols-2 gap-4 h-[180px]">
          <div className="bg-[#9747ff61] rounded-lg shadow p-4 flex flex-col relative overflow-hidden">
            <div className="title leading-none">Managed Wallet Address</div>
            <div className='text-[1.1rem] font-bold mt-2'>{shortenAddress(playerProfile.managedWalletAddress)}</div>
            <div className="absolute -bottom-2 -right-5 w-[100px]">
              <img src={IconBalance} />
            </div>
          </div>

          <div className="bg-[#9747ff61] rounded-lg shadow p-4 flex flex-col relative overflow-hidden">
            <div className="title">Balance</div>
            <div className='text-[1.1rem] font-bold mt-2'>{assets.balance} ETH</div>
            <div className="absolute -bottom-2 -right-5 w-[120px]">
              <img src={IconAddress} />
            </div>
          </div>
        </div>
      </div>

      <div className='flex justify-end'>
        <Link to="/connect-external-wallet" className='text-[#ffcc5a] bg-[#481C8E] border-2 rounded-lg py-1 px-4 uppercase font-bold'>
          Connect External Wallet
        </Link>
      </div>
      {/* {!connected ? (
        <div className="space-y-4">
          <h2 className="title">Connect External Wallet</h2>
          {wallets.map((wallet) => (
            <button
              key={wallet.id}
              onClick={() => connectWallet(wallet.id)}
              className="w-full bg-[#9747ff61] rounded-lg shadow p-4 flex items-center space-x-4"
            >
              <img
                src={wallet.icon}
                alt={wallet.name}
                className="w-8 h-8 invert"
              />
              <span>{wallet.name}</span>
            </button>
          ))}
        </div>
      ) : (
        <div className="space-y-6">
          <section>
            <h2 className="text-lg font-semibold mb-4">NFTs</h2>
            <div className="grid grid-cols-2 gap-4">
              {assets.nfts.map((nft) => (
                <div
                  key={nft.id}
                  className=" shadow-[0px_0px_25px_0px_rgba(255,46,255,0.9)] border-2 border-[#ffffff82] rounded-lg relative"
                >
                  {nft.rarity && (
                    <span className="absolute uppercase top-0 right-0 bg-purple-500 text-white px-2 font-bold rounded-bl-md rounded-tr-md text-xs">
                      {nft.rarity}
                    </span>
                  )}
                  <img
                    src={nft.image}
                    alt={nft.name}
                    className="w-full object-cover rounded-lg mb-2"
                  />
                  <div className=" absolute bottom-0 w-full flex justify-center">
                    <h3 className="font-semibold text-center bg-[#222222] p-1 rounded-t-lg border-2 text-sm border-[#ffffff82] border-b-0">{nft.name}</h3>
                  </div>
                  <p className="text-sm text-gray-600">{nft.collection}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      )} */}
    </div>
  );
};

export default Wallet;  